import { backofficeClient } from "shared/api/backofficeClient";

const PROFILE_URL = "/api/user/me";

export type CurrentUserDTO = {
  data?: {
    id: number;
    email: string;
  };
};

class AuthApi {
  /**
   * The back office answers 401 for a signed-out browser, which is the whole
   * signal we need: the session cookie is cross-subdomain, so nothing has to
   * be passed in from the page.
   */
  public me(signal?: AbortSignal): Promise<CurrentUserDTO> {
    return backofficeClient.get(PROFILE_URL, { ...(signal ? { signal } : {}) });
  }
}

const authService = new AuthApi();

export { authService };
